<mat-form-field class="opacity-0 !p-0">
  <mat-select (selectionChange)="onLanguageSelected($event.value)" [value]="translationEventService.selectedLanguage()">
    <mat-option [value]="{
      code: 'en',
      name: 'English'
    }">
      English 
    </mat-option>
    @for (language of languages(); track language.code) {
      <mat-option [value]="language">
        {{ language.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>